import React from 'react';
import Header from './Header';
import Footer from './Footer';
import AdSlot from './AdSlot';

export default function PageLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#F7FAFC] dark:bg-[#0B1220] flex flex-col relative transition-colors">
      <div className="ad-rail ad-rail-left" aria-hidden="true">
        <div className="ad-slot"><AdSlot side="left" /></div>
      </div>
      <div className="ad-rail ad-rail-right" aria-hidden="true">
        <div className="ad-slot"><AdSlot side="right" /></div>
      </div>

      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
